export const RangeErrorType = {
  Overlap: 'overlap',
  Gap: 'gap',
} as const;
export type RangeErrorType = (typeof RangeErrorType)[keyof typeof RangeErrorType];
